var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('OfflineBanner',{attrs:{"isVisible":!_vm.isOnline}}),(_vm.isServiceUnavailable)?_c('ServiceUnavailableView'):_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }